export default __webpack_public_path__ + "static/slider.wko.klein-c9bb327f7c9a2c2491f53a667cc83bf5.jpeg";